require('./contractEasyLoanStep4.scss');
require('react-pdf/dist/Page/AnnotationLayer.css');

const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const classnames = require('classnames');
const moment = require('moment');
//@core
const { FormattedText, formatText } = require('core/i18n').i18n;

//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { OKMessage } = require('commonsComponents/OKMessage');
// Components
const ContractLoanPdfViewerError = require('../../contractLoanPdfViewerError/contractLoanPdfViewerError');
const { ContractLoanPdfViewer } = require('../../contractLoanPdfViewer/contractLoanPdfViewer');
// @ CC Components
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { getPurposeTranslation } = require('components/contactCenter/contracts/contractEasyLoan/contractEasyLoanPurposes');
//@utilities
const { decimalsLength, getFormattedString, formatPercentage, formatNumber, formatAmount } = require('utilities/currencyHelper');
const { es: { DATE_FORMAT_WITH_SLASHES } } = require('commonsConstants/dateFormatTypes');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const download = require('downloadjs');
const { getLastNChars } = require('utilities/stringHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

//@constant
const { API_CENTER, API_ENTERPRISE_NUMBER } = require('constants/index');
const { CONTRACT_EASY_LOAN_ID, messages: { OPERATION_EASY_GDPR } } = require('constants/operationTypes');
const {
    amortizationTypes,
    contractEasyLoan,
    CONTRACT_DOCUMENT,
    INE_DOCUMENT,
    CONTRACT_DOCUMENT_NAME,
    INE_DOCUMENT_NAME,
    payrollLoanCommon,
    PRE_APPROVED_DOCUMENT,
    SERVICE_CONTRACT_FOR_PHYSICAL_PERSONS,
    DEFAULT_VIEWER_HEIGHT,
    PDF_VIEWER_SCALE
} = require('../../../../loansConstants/index');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const { NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES, EVIDENCE_EASY_LOAN } = require('constants/flagBasedFeatures');
const translationContractLoanPdfViewerINE = require("../../contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations");

class ContractEasyLoanStep4 extends React.Component {
    constructor(props) {
        super(props);
        this.handleDownloadINEDocument = this.handleDownloadINEDocument.bind(this);
        this.handleDownloandPDFDocument = this.handleDownloandPDFDocument.bind(this);
        this.handleOnPrintDocument = this.handleOnPrintDocument.bind(this);
        this.handleOnDownloadDocument = this.handleOnDownloadDocument.bind(this);
        this.handleOpenPdfNewTab = this.handleOpenPdfNewTab.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);

    }

    handleDocumentReaded() {
        const { handleScrolldownPolicy } = this.props;
        handleScrolldownPolicy()
    }
    componentWillUnmount() {
        __CONTACT_CENTER__ && this.props.resetPrecontractualMail();
    }

    handleDownloadINEDocument(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.props.downloadINEDocument();
    }

    handleDownloandPDFDocument(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.props.downloanEasyLoanContractDocument();
    }

    handleOpenPdfNewTab() {
        const { immContractEasyLoan } = this.props;
        const document = immContractEasyLoan.get('fileEasyLoanIneDocument');
        if(document){
            openBase64pdfInPrintWindow(document,true);
        }
    }
  
    buildHorizontalList() {
        const { immContractEasyLoan, immAccounts, immFlagBasedFeatures } = this.props;
        const immOpeningCommission = immContractEasyLoan.get('openingCommission');
        const openingCommissionAmount = immOpeningCommission.get('amount');
        const percentage = immOpeningCommission.get('percentage');
        const showBothCommissions = immOpeningCommission.get('showPercentajeCommission') && immOpeningCommission.get('showMinCommission');
        const decimalsLengthOpeningCommission = decimalsLength(openingCommissionAmount);
        const openingCommissionPercentage = percentage > 0 ? formatNumber(immOpeningCommission.get('percentage')) : percentage;
        const selectedAccount = immContractEasyLoan.get('selectedAccount');
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountAlias = immAccount.get('alias');
        const accountIban = getLastNChars(immAccount.get('iban'));
        let openingCommissionLabel;

        if (showBothCommissions) {
            const openingCommissionMinAmount = immOpeningCommission.get('minimum');
            const decimalLengthOpeningCommissionMin = decimalsLength(openingCommissionMinAmount);
            const openingCommissionMinFormatted = getFormattedString({
                amount: openingCommissionMinAmount,
                currency: immContractEasyLoan.get('currency'),
                decimalsLength: decimalLengthOpeningCommissionMin
            });

            openingCommissionLabel = [
                formatText('contractEasyLoanSidebar-openingCommissionWithPercentaje', [openingCommissionPercentage]),
                formatText('contractEasyLoanSidebar-openingCommissionMin', [openingCommissionMinFormatted])
            ];

        } else if (immOpeningCommission.get('showPercentajeCommission')) {
            openingCommissionLabel = formatText('contractEasyLoanSidebar-openingCommissionWithPercentaje', [openingCommissionPercentage]);
        } else {
            openingCommissionLabel = formatText('contractEasyLoanSidebar-openingCommission');
        }

        let fields = [
            {
                text: formatText('contractEasyLoanStepThree-loanImport'),
                value: getFormattedString({
                    amount: immContractEasyLoan.get('selectedAmount'),
                    currency: immContractEasyLoan.get('currency'),
                    decimalsLength: 0
                })
            },
            {
                text: formatText('contractEasyLoanStepThree-term'),
                value: formatText('contractEasyLoan-termMonths', [immContractEasyLoan.get('selectedTerm')])
            },
            {
                text: formatText('contractEasyLoanStepThree-monthlyInstallment'),
                value: getFormattedString(immContractEasyLoan.get('installment'))
            },
            {
                text: openingCommissionLabel,
                value: getFormattedString({
                    amount: openingCommissionAmount,
                    currency: immContractEasyLoan.get('currency'),
                    decimalsLength: decimalsLengthOpeningCommission
                }),
                additionalLabel: (<sup>1</sup>),
            },
        ];
       
        if (__CONTACT_CENTER__ && !isPrintOfficeMode() && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES)) {
            const footerList = [ 
            {
                text: formatText('contractLoanCompilationCard-TIN'),
                value: formatPercentage(immContractEasyLoan.get('tin')),
            },
            {
                text: formatText('contractLoanCompilationCard-TAE'),
                value: formatPercentage(immContractEasyLoan.get('tae'))
            },
            {
                text: formatText('contractEasyLoanSidebar-associatedAccount'),
                value: `${accountAlias} ${accountIban}`
            }]
            fields = fields.concat(footerList);
        }

        return fields.map((field, index) => {
            const className = classnames(
                'contract-easy-loan-step-four__horizontal-list-item',
                { 'contract-easy-loan-step-four__horizontal-list-item--first-element': index === 0 },
                { 'contract-easy-loan-step-four__horizontal-list-item--fourth-element': index === 4 }
            );

            return (
                <OKInformativeListItem
                    key={index}
                    title={field.text}
                    additionalLabel={field.additionalLabel}
                    bodyText={field.value}
                    className={className}
                />
            );
        });
    }

    buildSignaturePatternParams() {
        const { immContractEasyLoan, immAccounts, immFlagBasedFeatures } = this.props;

        const selectedAmount = immContractEasyLoan.get('selectedAmount');
        const currency = immContractEasyLoan.get('currency');

        const selectedAccount = immContractEasyLoan.get('selectedAccount');
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountProduct = immAccount.get('newProduct');
        const accountContract = immAccount.get('newContractNumber');

        const originAccount = API_ENTERPRISE_NUMBER + API_CENTER + accountProduct + accountContract;

        const propositionYear = immContractEasyLoan.get('propositionYear');
        const propositionNumber = immContractEasyLoan.get('propositionNumber');
        const optional1 = API_ENTERPRISE_NUMBER + API_CENTER + propositionYear + propositionNumber;
        const operationProcessIdPolicy = immContractEasyLoan.get('operationProcessIdPolicy')

        return (immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && immFlagBasedFeatures.get(EVIDENCE_EASY_LOAN)) ? {
            ammount: selectedAmount,
            currency,
            optional1,
            originAccount,
            operationProcessId: operationProcessIdPolicy,
            evidenceType: "SIGN_DOCUMENT"
        }:{
            ammount: selectedAmount,
            currency,
            optional1,
            originAccount
        };
    }

    buildSignaturePattern() {
        const { immContractEasyLoan, immFlagBasedFeatures } = this.props;
        const operationParams = this.buildSignaturePatternParams();
        const agreeCheckbox = !__CONTACT_CENTER__ && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) ? immContractEasyLoan.get('agreeIneCheckbox') :immContractEasyLoan.get('agreeCheckbox');
        const checkboxFlag = immContractEasyLoan.get('checkboxFlag');
        const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES);
        const officePrintStepFour = immContractEasyLoan.get('officePrintStepFour');
        return agreeCheckbox ||  checkboxFlag || officePrintStepFour ? (
            <div>
                <hr />
                <GDPRSignaturePattern
                    operationType={CONTRACT_EASY_LOAN_ID}
                    operationParams={operationParams}
                    multiOTPGDPRMessageCode={OPERATION_EASY_GDPR}
                    isOverDraft={isPrintOfficeMode() ? false : true}
                    isEasyLoanTypeAB={newEasyLoanFF}
                    newOperationProcessId={operationParams.operationProcessId}
                    evidenceType={operationParams.evidenceType}
                />
            </div>
        ) : null;
    }

    handleCheckboxDownloadEvents(event, docType) {
        if (docType === INE_DOCUMENT) {
            this.handleDownloadINEDocument(event);
        } else if (docType === PRE_APPROVED_DOCUMENT) {
            this.handleDownloandPDFDocument(event);
        } else {
            window.open(SERVICE_CONTRACT_FOR_PHYSICAL_PERSONS);
        }
    }

    buildLinkButtonMessage(docType, documentName) {
        return (
            <OKButton
                onClick={event => this.handleCheckboxDownloadEvents(event, docType)}
                modifier="link-emphasize"
                autoHeight
                loading={false}
            >
                {documentName}
            </OKButton>
        )
    }

    buildCheckboxLabel(poeditorPrefix) {
        const getPoEditorKey = key => {
            return `${poeditorPrefix}-${poeditorPrefix}_${key}`;
        };
        const splitMessage = formatText(getPoEditorKey(`contractEasyLoanAgreeCheckboxLabel`)).split('%s');

        const injectedLinks = [
            { docType: INE_DOCUMENT, text: getPoEditorKey('contractEasyLoanIneDocument') },
            { docType: PRE_APPROVED_DOCUMENT, text: getPoEditorKey('contractEasyLoanPreApprovedDocument') },
            { docType: CONTRACT_DOCUMENT, text: getPoEditorKey('contractEasyLoanContractDocument') },
        ];

        const message = splitMessage.map((message, index) => {
            const link = injectedLinks[index];
            const documentName = link ? formatText(link.text) : '';
            const replacement = link ? this.buildLinkButtonMessage(link.docType, documentName) : '';

            return (
                <span key={index}>
                    {message}
                    {replacement}
                </span>
            );
        });

        return <span>{message}</span>;
    }
    
    handleOnPrintDocument(documentType = "") {
        const { immContractEasyLoan, immFlagBasedFeatures, setOfficeStep } = this.props;
        const document = documentType === INE_DOCUMENT ? immContractEasyLoan.get('fileEasyLoanIneDocument') : immContractEasyLoan.get('fileEasyLoanPolicyDocument');
        if(document){
            openBase64pdfInPrintWindow(document);
            isPrintOfficeMode() && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && setOfficeStep("POLICY");
        }     
    }
    
    handleOnDownloadDocument(documentType = "") {
        const { immContractEasyLoan } = this.props;
        let documentName = '';
        let document;  
               
        if(documentType === INE_DOCUMENT) {
            document = immContractEasyLoan.get('fileEasyLoanIneDocument');
            documentName = INE_DOCUMENT_NAME;
        } else {
            document = immContractEasyLoan.get('fileEasyLoanPolicyDocument');
            documentName = CONTRACT_DOCUMENT_NAME;
        }
        download(document, documentName, 'application/pdf');
    }

    buildViewer() {
        const {
            immContractEasyLoan,
            onDownloadDocument,
            onPrintDocument,
            getHiringDocuments,
            toggleAgreeCheckbox,
            immFlagBasedFeatures
        } = this.props;

        const documents = immContractEasyLoan.get('documents');
        const isFetchingPrintDocuments = immContractEasyLoan.get('isFetchingPrintDocuments');
        const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES);
        const showBlockInfo = newEasyLoanFF && isPrintOfficeMode();
        const agreeCheckbox = newEasyLoanFF ? immContractEasyLoan.get('agreeIneCheckbox') :immContractEasyLoan.get('agreeCheckbox');
        const validate = immContractEasyLoan.get('showErrorMessage');
        const downloadError = immContractEasyLoan.get('downloadError');
        const loadingDownload = immContractEasyLoan.get('isFetchingZip');
        const isLoading = immContractEasyLoan.get('isFetchingDocuments');
        const errorLoading = immContractEasyLoan.get('errorDocuments');

        const poeditorPrefix = 'contractEasyLoanStepThree';
        const title = newEasyLoanFF ? formatText(`${poeditorPrefix}-${poeditorPrefix}_newtitle`) : formatText(`${poeditorPrefix}-${poeditorPrefix}_title`);
        const productName = formatText("contractEasyLoanStepThree-contractEasyLoanStepThree_productName");
        const checkboxLabel = this.buildCheckboxLabel(poeditorPrefix);
        return (
            !immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) ?
                <ContractLoanPdfViewer
                    agreeCheckbox={agreeCheckbox}
                    checkboxLabel={checkboxLabel}
                    document={documents}
                    downloadError={downloadError}
                    errorLoading={errorLoading}
                    getDocuments={getHiringDocuments}
                    hasSignaturePattern
                    isCallingDownloadService={isFetchingPrintDocuments}
                    isLoading={isLoading}
                    loadingDownload={loadingDownload}
                    onAgreeCheckbox={toggleAgreeCheckbox}
                    onDownload={() => onDownloadDocument(productName)}
                    onPrint={onPrintDocument}
                    title={title}
                    validate={validate}
                    showOfficeCheckBox={isPrintOfficeMode() && !newEasyLoanFF}
                    viewerHeight={DEFAULT_VIEWER_HEIGHT}
                    onDocumentReaded={this.handleDocumentReaded}

                />
                :
                <div>
                    <h4 className="contract-loan-pdf-viewer__subtitle">
                        <strong>
                            <FormattedText value={translationContractLoanPdfViewerINE.SUBTITLE_CONFIRM_PAGE} />
                        </strong>
                    </h4>
                    <div className="contract-actions-readed">
                        <button className="link--red" onClick={() => this.handleOpenPdfNewTab()}>
                            <FormattedText value={translationContractLoanPdfViewerINE.EASY_LOAN_TEXT_CONFIRM_PAGE}/>
                        </button>
                        <span><i className="signature-pattern-code-input__icon icon icon-check"/>
                            <FormattedText className="signature-text" value={translationContractLoanPdfViewerINE.LEGAL_INFO_READ_BUTTON} />
                        </span>
                    </div>
                    <div className="contract-easy-loan-step-four__informative-text">
                        <FormattedText value={translationContractLoanPdfViewerINE.EASY_LOAN_SUBTITLE_STEP4} />
                    </div>
                    {showBlockInfo && <BlockInfo>
                        <FormattedText value={"contractEasyLoanStepFour-contractBlockTitle"} className="contract-easy-loan-step-four informative-title" /><br/>
                        <FormattedText value={"contractEasyLoanStepFour-contractBlockSubTitle"} />
                    </BlockInfo>}
                </div>
                
        );
    }

    buildLegalDraftContract() {
        const { immContractEasyLoan, getEasyLoanPolicyDocument, immFlagBasedFeatures } = this.props;
        const errorLoading = immContractEasyLoan.get('errorEasyLoanContractDocument');
        const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES);
        const agree = isPrintOfficeMode() && newEasyLoanFF ? true : newEasyLoanFF && immContractEasyLoan.get('agreeIneCheckbox');
        const fileDraftDocument = immContractEasyLoan.get('fileEasyLoanPolicyDocument');
        const operationProcessId = immContractEasyLoan.get('operationProcessIdPolicy')
        return agree ? (
            <OKPdfViewer
                onDownload={() => this.handleOnDownloadDocument(fileDraftDocument)}
                onPrint={() => this.handleOnPrintDocument(fileDraftDocument)}
                pdfFile={fileDraftDocument}
                title={formatText(translationContractLoanPdfViewerINE.EASY_LOAN_TITLE_CONTRACT_DRAFT_DOCUMENT)}
                scale={PDF_VIEWER_SCALE}
                infiniteScroll
                failedLoadingPdf={errorLoading}
                errorComponent={() => {
                    return <ContractLoanPdfViewerError 
                    getDocuments={getEasyLoanPolicyDocument}
                    operationProcessId={operationProcessId}
                 />
                }}
                viewerHeight={DEFAULT_VIEWER_HEIGHT}
                onDocumentReaded={this.handleDocumentReaded}        
                />
            ) 
            :
            null
    }

    buildPreContractualMailInfo() {
        const {
            immProfile,
            immContractEasyLoan,
            immAccounts,
            preContractualMail,
            requestProfile,
            sendMail,
            immFlagBasedFeatures,
            getLoanContractDocuments,
            getEasyLoanPolicyDocument,
            sendEasyLoanSimpleEmail
        } = this.props;

        const clientEmail = PersonalDataHelper.getEmail(immProfile);
        const refreshEmailError = immProfile.get('error');
        const indCapson = immContractEasyLoan.get('indCapson');
        const selectedAccount = immContractEasyLoan.get('selectedAccount');
        const endOfMonth = immContractEasyLoan.get('paymentDaySelected') === contractEasyLoan.PAYMENT_DAY_END_OF_MONTH;
        const financedCommission = indCapson === amortizationTypes.YES ? payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA;
        const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES);
        const evidenceFF = immFlagBasedFeatures.get(EVIDENCE_EASY_LOAN);
        const mailAPIFlag = immContractEasyLoan.get('mailAPIFlag');
        const getLoanContractDocument = newEasyLoanFF && evidenceFF ? getLoanContractDocuments:newEasyLoanFF && !evidenceFF ? getEasyLoanPolicyDocument:null;
        const sendMailParams = {
            amount: formatAmount(immContractEasyLoan.get('selectedAmount')),
            calculatedOpeningCommission: formatAmount(immContractEasyLoan.getIn(['openingCommission', 'amount'])),
            capitalizedOpeningCommissionIndicator: indCapson,
            clientAccountCode: immAccounts.getIn(['byId', selectedAccount, 'iban']),
            dueDate: moment(immContractEasyLoan.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth,
            financedCommission,
            firstTime: true,
            loanPurpose: getPurposeTranslation(immContractEasyLoan.get('selectedPurpose')),
            productDuration: immContractEasyLoan.get('selectedTerm').toString(),
            productType: contractEasyLoan.PRODUCT_TYPE,
            propositionContractNumber: immContractEasyLoan.get('contractNumber'),
            propositionNumber: immContractEasyLoan.get('propositionNumber', '').toString(),
            tae: formatAmount(immContractEasyLoan.get('tae')),
            tin: formatAmount(immContractEasyLoan.get('tin')),
            year: immContractEasyLoan.get('propositionYear'),
        };

        return (
            <PreContractualMailInfo
                email={clientEmail}
                preContractualMail={preContractualMail}
                profileError={refreshEmailError}
                requestProfile={requestProfile}
                sendEmail={sendMail}
                sendMailParams={sendMailParams}
                showLegalText={false}
                legalInfoText={newEasyLoanFF ? false : true}
                sendSimpleEmail={sendEasyLoanSimpleEmail}
                mainFlag={'EASY_LOAN'}
                contractObj={immContractEasyLoan}
                getContractDraftDocument={getLoanContractDocument}
                disableSendButton={newEasyLoanFF ? (!mailAPIFlag || immContractEasyLoan.get('isEasyLoanEmailInitError')): false}
                mainFeatureFlag={newEasyLoanFF}
                loadingSendButton={immContractEasyLoan.get('isFetchingINEDocument')}
            />
        );
    }

    buildContactCenterCheckboxLabel() {
        return (
            <React.Fragment>
                <FormattedText value="contractEasyLoanStepThree-checkboxTextPartOne" />
                <OKButton
                    autoHeight
                    modifier="link-emphasize"
                    onClick={this.handleDownloadINEDocument}
                >
                    <FormattedText value="contractEasyLoanStepThree-checkboxLinkLabelOne" />
                </OKButton>
                <FormattedText value="contractEasyLoanStepThree-checkboxTextPartTwo" />
                <OKButton
                    autoHeight
                    modifier="link-emphasize"
                    onClick={this.handleDownloandPDFDocument}
                >
                    <FormattedText value="contractEasyLoanStepThree-checkboxLinkLabelTwo" />
                </OKButton>
                <FormattedText
                    className="contract-easy-loan-step-four__checkbox-label contract-easy-loan-step-four__checkbox-label--with-left-padding"
                    value="contractEasyLoanStepThree-checkboxTextPartThree"
                />
                <OKLink
                    modifier="emphasize"
                    target="_blank"
                    to={formatText('contractsView-pdfLinkforCPS')}
                >
                    <FormattedText value="contractEasyLoanStepThree-checkboxLinkLabelThree" />
                </OKLink>
                <FormattedText value="contractEasyLoanStepThree-checkboxTextPartFour" />
            </React.Fragment>
        );
    }

    buildContactCenterCheckboxElement(newEasyLoanFF) {
        const { immContractEasyLoan, preContractualMail, toggleAgreeCheckbox} = this.props;
        const checkboxLabel = this.buildContactCenterCheckboxLabel();
        const errorMessage = formatText('contractEasyLoanStepThree-checkboxErrorMessage');
        const mailSent = !newEasyLoanFF ? preContractualMail.get('mailSent') : immContractEasyLoan.get('isEasyLoanEmailSent');
        const agreeCheckbox = (!__CONTACT_CENTER__ && isPrintOfficeMode()) && newEasyLoanFF  || (isPrintOfficeMode() && newEasyLoanFF) ? immContractEasyLoan.get('agreeIneCheckbox') : immContractEasyLoan.get('agreeCheckbox');
        const checkboxFlag= immContractEasyLoan.get('checkboxFlag');
        return (
            newEasyLoanFF ?
            <OKCheckbox
                idName="contract-easy-loan-step-four-agree-checkbox"
                label={<FormattedText value="contractEasyLoanStepThree-checkboxText" />}
                onChange={toggleAgreeCheckbox}
                value={agreeCheckbox || checkboxFlag}
                errorState={immContractEasyLoan.get('showErrorMessage')}
                errorMessage={errorMessage}
                disabled={!mailSent || checkboxFlag}
            />
            :
            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check" hasCheckbox>
                <OKCheckbox
                    idName="contract-easy-loan-step-four-agree-checkbox"
                    label={checkboxLabel}
                    onChange={toggleAgreeCheckbox}
                    value={agreeCheckbox}
                    errorState={immContractEasyLoan.get('showErrorMessage')}
                    errorMessage={errorMessage}
                    disabled={!mailSent}
                />
            </BlockInfo>
        );
    }

    buildQuestion(text) {
        const { immProfile } = this.props;
        const name = PersonalDataHelper.getFullName(immProfile, false);
        const keyName = `<b>${name}</b>`;

        return (<FormattedText value={text} injectedStrings={[keyName]} />);
    }
    
    buildNameBlock(text) {
        const { immProfile } = this.props;
        const name = PersonalDataHelper.getFullName(immProfile, false);

        return (<BlockInfo><FormattedText value={text} injectedStrings={[name]} /></BlockInfo>);
    }

    buildLegalText(newEasyLoanFF) {
        return  (
            newEasyLoanFF ? 
            <div className="contract-easy-loan-step-four__informative-text">
                <OKMessage type="informative">
                    <FormattedText value="contractEasyLoanStepThree-informativeTitle" className="contract-easy-loan-step-four__informativeTitle" /> <br />
                    <FormattedText value="contractEasyLoanStepThree-informativeSubTitle" />
                </OKMessage>
            </div> 
            :
            <div className="no-print-out">
            <p className="contract-easy-loan-step-four__precontractual-info-mandatory-title">
                <FormattedText value="contractEasyLoanStepThree-precontractualInfoTitle" />
            </p>
            <div className="contract-easy-loan-step-four__precontractual-info-mandatory-reading-section">
                <div className="contract-easy-loan-step-four__precontractual-info-mandatory-reading-content">
                    <HTMLSafeInjector message={formatText('contractEasyLoanStepThree-precontractualInfoLegalText')} />
                </div>
            </div>
        </div> 
        );
    }

    buildInformativeText() {
        return (
            <div className="contract-easy-loan-step-four__information">
                <i className="icon-informacion"></i>
                 <FormattedText value="preContractualMailInfo-information" ></FormattedText>
            </div>
        );
    }

    buildAcceptLegalText() {
        return (
            <div className="contract-easy-loan-step-four__subtitle">
                <FormattedText value="contractEasyLoanStepThree-legalText"></FormattedText>
            </div>
        );
    }

    render() {
        const { immFlagBasedFeatures } = this.props;
        const horizontalList = this.buildHorizontalList();
        const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES)
        const pdfViewer = !__CONTACT_CENTER__ || (isPrintOfficeMode() && newEasyLoanFF ) ? this.buildViewer() : null;
        const signaturePattern = this.buildSignaturePattern();

        const legalDraftContract = (!__CONTACT_CENTER__ || isPrintOfficeMode()) && this.buildLegalDraftContract();
        let precontractualMailInfo;
        let confirmationQuestion;
        let requestPurchaseConfirmation;
        let legalText;
        let checkbox;
        let infoText;
        let acceptLegalText;

        if (__CONTACT_CENTER__ && ((newEasyLoanFF && !isPrintOfficeMode()) || !newEasyLoanFF)) {
            requestPurchaseConfirmation = newEasyLoanFF ? this.buildNameBlock('contractEasyLoanStepThree-blockInfoSubTitle') : this.buildQuestion('contractEasyLoanStepThree-easyLoanConfirmationSentence');
            precontractualMailInfo = this.buildPreContractualMailInfo();
            legalText = this.buildLegalText(newEasyLoanFF);
            confirmationQuestion = this.buildQuestion('confirmationScript-promptMsg');
            checkbox = this.buildContactCenterCheckboxElement(newEasyLoanFF);
            infoText = this.buildInformativeText()
            acceptLegalText = this.buildAcceptLegalText()
        }

        return (
            <section className="contract-easy-loan-step-four">
                <div className="contract-easy-loan-step-four__title">
                    <FormattedText value="contractEasyLoanStepThree-title" />
                </div>
                {!newEasyLoanFF && requestPurchaseConfirmation}
                <div className="contract-easy-loan-step-four__message">
                    <FormattedText value="contractEasyLoanStepThree-message" />
                </div>
                {newEasyLoanFF && <div className="contract-easy-loan-step-four__informative-text" >{requestPurchaseConfirmation}</div>}
                <div>
                    {horizontalList}
                </div>
                {newEasyLoanFF && legalText}
                <div>
                    <OKConsents placementId="purchaseEasyLoan" />
                </div>
                {newEasyLoanFF && acceptLegalText}
                {pdfViewer}
                {legalDraftContract}
                {precontractualMailInfo}
                {!newEasyLoanFF && legalText}
                <div className="contract-easy-loan-step-four__checkbox-container">
                    {checkbox}
                </div>
                {newEasyLoanFF && infoText}
                {!newEasyLoanFF && <div className="contract-easy-loan-step-four__confirmation-question">{confirmationQuestion}</div>}
                {signaturePattern}
            </section>
        );
    }
}

ContractEasyLoanStep4.propTypes = {
    downloadINEDocument: PropTypes.func.isRequired,
    downloanEasyLoanContractDocument: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    getINEDocument: PropTypes.func.isRequired,
    getEasyLoanPolicyDocument: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    onDownloadDocument: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendMail: PropTypes.func.isRequired,
    toggleAgreeCheckbox: PropTypes.func.isRequired,
    setOfficeStep:PropTypes.func,
    getLoanContractDocuments: PropTypes.func,
    sendEasyLoanSimpleEmail: PropTypes.func
};

module.exports = ContractEasyLoanStep4;